import { FETCH_INSTITUTION_ADDRESS_DATA } from 'stores/redux/actions/types';
import reducer from '../common/reducer';

const addReducer = reducer(FETCH_INSTITUTION_ADDRESS_DATA);
export default addReducer;
